<template>
  <AppDialog
    v-model="isDialogOpen"
    :header="heading"
    :message="message"
    @click:close="$emit('close')"
  >
    <template #actions>
      <AppButton
        variant="outline"
        :label="cancelButtonLabel"
        @click="handleCancel"
      />
      <AppButton
        variant="primary"
        :label="confirmButtonLabel"
        @click="handleConfirm"
      />
    </template>
  </AppDialog>
</template>

<script setup lang="ts">
const props = defineProps({
  modelValue: {
    type: Boolean,
    required: true,
  },
  heading: {
    type: String,
    required: true,
  },
  message: {
    type: String,
    required: false,
    default: undefined,
  },
  confirmButtonLabel: {
    type: String,
    required: false,
    default: 'Confirm',
  },
  cancelButtonLabel: {
    type: String,
    required: false,
    default: 'Cancel',
  },
})

const emit = defineEmits(['update:modelValue', 'resolve', 'close'])

const isDialogOpen = computed({
  get() {
    return props.modelValue
  },
  set(value: boolean) {
    emit('update:modelValue', value)
  },
})

function handleConfirm() {
  emit('resolve', true)
  isDialogOpen.value = false
}

function handleCancel() {
  emit('resolve', false)
  isDialogOpen.value = false
}
</script>
